/**
 * How an agent came into the portal.
 *
 * STANDARD agents are contracted: they carry a commission level and work
 * through contracting before anything else. RING_IQ agents are dialer-only —
 * invited for Ring IQ alone, with no commission level and no contracting, so
 * their setup starts at the dialer fee.
 */
export const PORTAL_ACCOUNT_TYPES = ["STANDARD", "RING_IQ"];
export const PORTAL_ACCOUNT_TYPE_LABELS = {
    STANDARD: "Contracted agent",
    RING_IQ: "RingIQ",
};
export function isPortalAccountType(value) {
    return typeof value === "string" && PORTAL_ACCOUNT_TYPES.includes(value);
}
/** Registration links come in one flavour per account type they create. */
export const REFERRAL_CODE_KINDS = ["STANDARD", "RING_IQ"];
export const REFERRAL_CODE_KIND_DETAILS = {
    STANDARD: {
        label: "Contracted agent",
        description: "Carries a commission level. The agent starts at contracting and works through the whole setup.",
        accountType: "STANDARD",
    },
    RING_IQ: {
        label: "RingIQ",
        description: "Dialer only — no commission level and no contracting. The agent starts at the dialer fee.",
        accountType: "RING_IQ",
    },
};
export function isReferralCodeKind(value) {
    return typeof value === "string" && REFERRAL_CODE_KINDS.includes(value);
}
/** RingIQ links are dialer-only, so a commission level on one is meaningless. */
export function referralKindCarriesCommission(kind) {
    return kind === "STANDARD";
}
/** RingIQ agents never contract, so nothing should ask them to. */
export function accountTypeRequiresContracting(accountType) {
    return accountType === "STANDARD";
}
